import { DropboxEntry } from "./types";
import { convertEntry } from "./convertEntry";
import { EntryType } from "../types";
import getDropbox from "../../../../api/dropbox";

const dropbox = getDropbox();

export const fetchFileList = (id?: string) => (
  dropbox.filesListFolder({ path: id || "" })
    .then(({ entries }) => ((entries as Array<DropboxEntry>))
      .map(convertEntry)
      .filter(({ type }) => type !== EntryType.unknown))
    .catch((error) => {
      console.log(error);
      throw new Error("Dropbox");
    })
);
